import { isArray, isDefined, PolygonNode } from "../../infra3d";
import { Geometry, GEOMETRYTYPE, PickData } from "./internal";
/**
 * Representation of the FeatureCollection-Object specified in GeoJSON-Standard.
 *
 * @class FeatureCollection
 * @author Ported by Benjamin Loesch, based on code by Kevin Flueckiger
 * @extends Geometry
 */
export class PolygonGeometry extends Geometry {
    constructor(parentfeature) {
        super(parentfeature);
        this.type = GEOMETRYTYPE.POLYGON;
        this.parent = parentfeature;
        this.scene = parentfeature.scene;
    }
    /**
     * Parse the Geometry from a JSON-Object
     * @method parseFromJSON
     * @param {Object} json The JSON Object
     */
    parseFromJSON(json) {
        if (isDefined(json["coordinates"])) {
            this.type = Geometry.toNumber(json["type"]);
            let bError = false;
            const ls = json["coordinates"][0];
            for (let i = 0; i < ls.length; i++) {
                if (!isArray(ls[i]))
                    bError = true;
            }
            // If the coordinate-Array is valid, assign it to the Geometries-Coorinate-Property.
            if (bError) {
                throw "Something worng with coordinates array of polygongeometry";
            }
            else {
                const coords = json["coordinates"][0].slice(0);
                coords.pop(); // pop last element of geoJSON def
                this.coordinates = coords;
                this._create();
            }
        }
    }
    _create() {
        if (this.coordinates.length > 0) {
            this.node = new PolygonNode(this.coordinates, this.parent.style.toMaterialDefinitions(this.parent.properties), this);
            this.scene.add(this.node);
            this.created = true;
        }
    }
    clear() {
        this.created = false;
        if (this.node)
            this.scene.remove(this.node);
        this.coordinates = [];
    }
    /**
     * returns the Geometry content as GeoJson string
     *
     * @method toGeoJsonString
     * @return {string}
     */
    toGeoJsonString() {
        const objparts = {};
        objparts["type"] = Geometry.toString(this.type);
        const coords = this.coordinates.slice(0);
        coords.push(coords[0]);
        objparts["coordinates"] = [coords];
        return JSON.stringify(objparts);
    }
    /**
     * Removes the Geometry from the Render-Engine and destroys it.
     * @method destroy
     */
    destroy() {
        this.coordinates = [];
        this.type = null;
        if (this.created) {
            this.scene.remove(this.node);
            this.node.destroy();
        }
        this.id = null;
        this.created = false;
    }
    /**
     * Shows the geometry in Higlight-Style
     * @method highlightOn
     */
    highlightOn() {
        super.highlightOn();
        if (this.created) {
            this.node.setStyle(this.parent.highlightstyle.toMaterialDefinitions(this.parent.properties));
        }
    }
    /**
     * Shows the geometry in Higlight-Style
     * @method highlightOff
     */
    highlightOff() {
        super.highlightOff();
        if (this.created) {
            this.node.setStyle(this.parent.style.toMaterialDefinitions(this.parent.properties));
        }
    }
    movePoint(newcoord, index) {
        if (this.created) {
            this.coordinates[index] = newcoord;
            this.update();
        }
    }
    /**
     * Insert a point in the geomtery at a certain position
     * @method insertPoint
     * @param {number[]} newcoord
     * @param {number} index
     */
    insertPoint(newcoord, index) {
        if (index >= 0 && index < this.coordinates.length) {
            this.coordinates.splice(index, 0, newcoord);
            this.update();
        }
    }
    /**
     * Delete a point in the geomtery at a certain position
     * @method deletePoint
     * @param {number} index
     */
    deletePoint(index) {
        if (index >= 0 && index < this.coordinates.length) {
            this.coordinates.splice(index, 1);
            this.update();
        }
    }
    /**
     * Updates the Geometry
     * @method update
     */
    update() {
        if (!this.created) {
            this._create();
        }
        else {
            if (!this.parent.highlighton) {
                this.node.setStyle(this.parent.style.toMaterialDefinitions(this.parent.properties));
            }
            else {
                this.node.setStyle(this.parent.highlightstyle.toMaterialDefinitions(this.parent.properties));
            }
            this.node.updateCoordinates(this.coordinates);
        }
    }
    /**
     * Shows the Geometry. It sets hide to false and updates the geometry.
     * @method show
     */
    show() {
        super.show();
        if (this.created)
            this.node.show();
    }
    /**
     * Hides the Geometry. It sets hide to true and updates the geometry.
     * @method hide
     */
    hide() {
        super.hide();
        if (this.created)
            this.node.hide();
    }
    /**
     * Checks if the node was picked by mouse
     * @method hide
     */
    pick(mx, my, pickeddataarray) {
        if (this.created) {
            const p = this.node.pick(mx, my);
            if (p.length > 0) {
                const pdata = new PickData();
                pdata.feature = this.parentfeature;
                pdata.mindist = p[0].distance;
                pdata.mx = mx;
                pdata.my = my;
                pdata.found = true;
                pdata.disttopoint = p[0].distance;
                pdata.found_mx = p[0].point[0];
                pdata.found_my = p[0].point[1];
                pdata.geometry = this;
                pickeddataarray.push(pdata);
            }
        }
    }
}
//# sourceMappingURL=polygongeometry.js.map